import React from 'react';
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import ContactForm from "../components/ContactForm";

function ContactView() {
    return (
        <div className="min-h-screen bg-gray-50">
            <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                <Hero/>
                <h2 className="text-2xl font-bold text-center text-gray-900 mb-12">
                   Formularz kontaktowy
                </h2>
                <ContactForm/>
            </div>
            <Footer/>
        </div>
    );
}

export default ContactView;
